import { render, staticRenderFns } from "./longformtextDefault.vue?vue&type=template&id=4457b7f4"
import script from "./longformtextDefault.vue?vue&type=script&lang=js"
export * from "./longformtextDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports